export default "__VITE_ASSET__DnVIOIvn__"